var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3618 10.4231L9.29932 15.4856C9.22022 15.5646 9.11299 15.609 9.00119 15.609C8.8894 15.609 8.78217 15.5646 8.70307 15.4856L3.64057 10.4231C3.56605 10.3432 3.52548 10.2374 3.52741 10.1281C3.52934 10.0188 3.57361 9.91451 3.65091 9.83721C3.7282 9.75992 3.83248 9.71564 3.94178 9.71371C4.05107 9.71179 4.15685 9.75235 4.23682 9.82687L8.57932 14.1687V2.8125C8.57932 2.70061 8.62377 2.59331 8.70288 2.51419C8.782 2.43507 8.88931 2.39063 9.00119 2.39062C9.11308 2.39063 9.22039 2.43507 9.29951 2.51419C9.37862 2.59331 9.42307 2.70061 9.42307 2.8125V14.1687L13.7656 9.82687C13.8455 9.75235 13.9513 9.71179 14.0606 9.71371C14.1699 9.71564 14.2742 9.75992 14.3515 9.83721C14.4288 9.91451 14.4731 10.0188 14.475 10.1281C14.4769 10.2374 14.4363 10.3432 14.3618 10.4231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.0ad178607a6cddf1a95dfebb4a34e704.svg";
export { ForwardRef as ReactComponent };